import React, { memo } from 'react'

import { Popover } from '@mui/material'

import { ColorPickerItem, ColorPickerWrapper } from './index.styles'

export interface ColorPickerProps {
  colors: string[]
  size?: string
  selectedColor?: string
  anchorEl?: HTMLElement
  onColorPicked: (color: string | undefined) => void
}

const ColorPickerPopover = ({ colors, size = '14px', selectedColor, onColorPicked, anchorEl }: ColorPickerProps) => {
  const isPopoverOpen = Boolean(anchorEl)

  return (
    <Popover
      data-testid="color_picker_testid"
      open={isPopoverOpen}
      anchorEl={anchorEl}
      onClose={() => onColorPicked(selectedColor)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <ColorPickerWrapper>
        {colors.map(color => (
          <ColorPickerItem
            key={color}
            $color={color}
            $size={size}
            $isSelected={color === selectedColor}
            onClick={() => onColorPicked(color)}
          />
        ))}
      </ColorPickerWrapper>
    </Popover>
  )
}

export default memo(ColorPickerPopover)
